export const addListRallySelector = store => store.listRally;
export const addResultByRallySelector = store => store.resultByRally;
export const specialByRallySelector = store => store.specialByRally;
export const specialByRallySelectorRecap = store => store.specialByRallyrecap;
export const addResultBySpecialSelector = store => store.resultBySpecial;
export const addListClasseSelector = store => store.listClasse;
